export class ListAzureSKUs200Response {
    'skus';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "skus",
            "baseName": "skus",
            "type": "Array<ListAzureSKUs200ResponseSkusInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureSKUs200Response.attributeTypeMap;
    }
    constructor() {
    }
}
